<div class="login-title-section mb-2">
  <fgbcl-errors></fgbcl-errors>
</div>

<div class="form-group mb-2 mt-4 mt-lg-0">
  <button (click)="loginTM()" class="btn btn-tm btn-block login-button font-size-14 rounded-4">
    Login with <img class="ms-2" src="assets/images/ticketmaster.svg" draggable="false" />
  </button>
</div>